import { render } from "./WeldField.vue?vue&type=template&id=658123a9"
import script from "./WeldField.vue?vue&type=script&lang=js"
export * from "./WeldField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__